import { createFileRoute } from "@tanstack/react-router";
import { z } from 'zod';
import { OrgSettingsDetail } from "../../pages/OrgSettingsDetail";

// Search params schema for tab persistence
const orgSettingsSearchSchema = z.object({
  tab: z.enum(['general', 'email', 'portal', 'tickets', 'users', 'categories', 'collections', 'automation', 'deleted', 'held']).optional().catch('general'),
});

export const Route = createFileRoute("/helpdesk/org-settings/$orgId")({
  validateSearch: orgSettingsSearchSchema,
  component: OrgSettingsDetail,
});
